import { List, Stack, Text, Title } from '@mantine/core';

export const Troubleshooting = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Troubleshooting</Title>

            <Title order={4} td="underline">Account Not Found</Title>

            <Text>If you see "Account Not Found" after signing in, it means the email address you authenticated with does not match any of your saved accounts. This can happen if:</Text>

            <List spacing="sm">
                <List.Item>You signed in with a different email than the one saved on this device</List.Item>
                <List.Item>Your account was recently created and has not been synced yet</List.Item>
            </List>

            <Text>Click "Start Over" to return to the account selection screen and try again.</Text>

            <Title order={4} td="underline">Browser Not Supported</Title>

            <Text>If you see a "Browser Not Supported" message, your browser is too old to run this application. Please update to one of the following:</Text>

            <List spacing="sm">
                <List.Item>Google Chrome 93 or later</List.Item>
                <List.Item>Microsoft Edge 93 or later</List.Item>
                <List.Item>Mozilla Firefox 95 or later</List.Item>
                <List.Item>Apple Safari 15.4 or later</List.Item>
            </List>

            <Title order={4} td="underline">Offline</Title>

            <Text>If you lose your internet connection, you will be redirected to an offline page. The application will automatically return to the sign-in screen when your connection is restored.</Text>

            <Title order={4} td="underline">Password Reset Email Not Received</Title>

            <List spacing="sm">
                <List.Item>Check your spam or junk folder</List.Item>
                <List.Item>Make sure you entered the correct email address</List.Item>
                <List.Item>Wait a few minutes and try again</List.Item>
                <List.Item>Contact your administrator if the problem persists</List.Item>
            </List>

            <Title order={4} td="underline">SSO Redirect Not Working</Title>

            <List spacing="sm">
                <List.Item>Make sure your browser allows pop-ups and redirects</List.Item>
                <List.Item>Clear your browser cache and try again</List.Item>
                <List.Item>Contact your organization's IT administrator — the issue may be with your company's identity provider</List.Item>
            </List>
        </Stack>
    );
};
